
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_gelderland/themas/[slug]",
      function () {
        return require("private-next-pages/_sites/_gelderland/themas/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_gelderland/themas/[slug]"])
      });
    }
  